/*
 * Copyright (c) 2022 automata-network/tgb-donation authors and contributors.
 * This software may be modified and distributed under the terms of MIT license.
 * Refer to the LICENSE file for details.
 */
import { useEffect } from 'react'

import { Outlet } from 'react-router-dom'
import styled, { css } from 'styled-components'

import ModalV2, { useModalV2Context } from 'src/features/modal-v2'

import ornamentLeft from '../assets/ornament-l.png'
import ornamentRight from '../assets/ornament-r.png'
import Toast from '../components/Common/Toast'
import Footer from '../components/Footer'
import Modal from '../components/Modal'
import { NavBar } from '../components/NavBar'
import { useModalContext } from '../contexts/ModalContext'
import { useModalGuideContext } from '../contexts/ModalGuideContext'
import { pxToVw } from '../functions/units'
import { useBlockNumber } from '../hooks/useBlockNumber'

const AppLayout = () => {
  const { modalIsOpen, modalConfig, ModalViewProxy } = useModalContext()
  const {
    modalIsOpen: modalGuideIsOpen,
    modalConfig: modalGuideConfig,
    ModalViewProxy: ModalGuideViewProxy
  } = useModalGuideContext()
  const { hasActiveModals } = useModalV2Context()

  useBlockNumber()

  useEffect(() => {
    if (hasActiveModals || modalIsOpen) {
      document.body.classList.add('modal-open')
    } else {
      document.body.classList.remove('modal-open')
    }
  }, [hasActiveModals, modalIsOpen])

  return (
    <>
      <NavBar />

      <StyledMain>
        <Outlet />
      </StyledMain>

      <Footer />

      <Modal isOpen={modalIsOpen} config={modalConfig}>
        <ModalViewProxy />
      </Modal>

      <Modal modalGuide isOpen={modalGuideIsOpen} config={modalGuideConfig}>
        <ModalGuideViewProxy />
      </Modal>

      {hasActiveModals && <ModalV2 />}

      <Toast />
    </>
  )
}

export default AppLayout

const StyledMain = styled.main`
  position: relative;
  padding-inline: ${pxToVw(250)};

  > * {
    position: relative;
    z-index: 2;
  }

  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 20.78125vw;
    height: 37.76vw;
    background: url(${ornamentLeft}) no-repeat 0 0 / cover;
    z-index: 1;
  }

  &::after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    width: 34.6875vw;
    height: 31.61458vw;
    background: url(${ornamentRight}) no-repeat 0 0 / cover;
    z-index: 1;
  }

  ${({ theme }) => css`
    ${theme.mediaQuery.mobile`
      padding-inline: ${pxToVw(60, 720)};

      &::before {
        display: none;
      }

      &::after {
        width: ${pxToVw(451, 720)};
        height: ${pxToVw(635, 720)};
        background: url(${ornamentLeft}) no-repeat 0 0 / contain;
        transform: rotateY(180deg);
      }
    `}
  `}
`
